module.exports = __webpack_public_path__ + "img/broken-image.f6412448.svg";